import React from 'react';
import { Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import BalancingScale from '../assets/images/circle-balancing-scale.svg';
import LightBulb from '../assets/images/circle-light-bulb.svg';
import OpposingArrows from '../assets/images/circle-opposing-arrows.svg';
import ArrowForward from '../assets/images/ArrowForward.svg';
import { PsBeaconButton, PsBeaconModal } from './shared/BeaconRegister';
import './EducationModal.css';

import NumberBadge from './NumberBadge';


export const EducationPageModal = ({ dispatch }) => {
    const handleOnClose = (e) => {
        e?.preventDefault();
        const educationModal = document.querySelector('#education-modal');
        if (educationModal !== null) educationModal.close();
    }

    const handleOnClick = () => {
        const clickPromise = new Promise((resolve) => {
            resolve(dispatch({
                type: 'EDUCATION_CONTINUE',
                educationContinue: true
            }))
        });
        clickPromise.then(() => handleOnClose());
    }

    return (
        <PsBeaconModal
            id='education-modal'
            scale='jumbo'
            elevation={3}
        >
            <div id='education-modal-content-container' className='beacon-theme-modern-outlook beacon-on-light'>
                <Typography type='headline' scale={300} serif id='education-title' className='educationTitle'>
                    Have you experienced a life event, or is it time for your annual check-in?
                </Typography>
                <div id='major-changes-container majorChangesContainer'>
                    <div id='major-change-section'>
                        <Typography type='headline' scale={100} loose bold id='major-change-header' className='sectionTitle'>
                            Examples of major changes
                        </Typography>
                        <div className='majorChangesExampleContainer'>
                            <Typography scale={200} bold id='major-change-examples' className='listContent'>
                                <div className='listItem listSeparator'>
                                    <img src={LightBulb} alt='recently-retired' id='retired-icon' />
                                    <div id='recently-retired' className='changes-content'>Recent retirement</div>
                                </div>
                                <div className='listItem listSeparator'>
                                    <img src={OpposingArrows} alt='brth-of-child-icon' id='birth-of-child-icon' />
                                    <div id='birth-of-child' className='changes-content'>Birth of a child</div>
                                </div>
                                <div className='listItem listSeparator'>
                                    <img src={OpposingArrows} alt='job-change-icon' id='job-change-icon' />
                                    <div id='job-change-child' className='changes-content'>Job change</div>
                                </div>
                                <div className='listItem'>
                                    <img src={BalancingScale} alt='unpl-change-icon' id='unpl-change-icon' />
                                    <div id='unpl-change-child' className='changes-content'>
                                        Unplanned changes to your financial situation, such as a family inheritance or large expense
                                    </div>
                                </div>
                            </Typography>
                            <div className='listContentGap'></div>
                        </div>
                    </div>
                </div>

                <div className='sectionSeparator'></div>

                <div id='annual-review-container' className='sectionContainer'>
                    <Typography loose bold scale={100} type='headline' id='annual-review-header' className='sectionTitle'>
                        Annual review
                    </Typography>
                    <Typography type='headline' scale={50} id='annual-review-content'>
                        Your annual review allows us to assess your portfolio and determine whether it is still aligned to your goals and needs.
                        This evaluation requires accurate and up-to-date information about you, your time horizon, and your goals.
                    </Typography>
                </div>

                <div className='sectionSeparator'></div>

                <div id='scenarios-container' className='sectionContainer'>
                    <Typography type='headline' loose scale={100} bold id='scenarios-header' className='sectionTitle'>
                        If either of these scenarios apply to you, please continue to other questionnaire
                    </Typography>
                    <Typography type='headline' scale={50} id='scenarios-content' className='scenariosContent'>
                        <div id='scenarios-sub-1' className='scenarioSubsection'>After completing the questionnaire:</div>
                        <Typography bold id='scenarios-sub-content' className='listContent'>
                            <div id='scenario-step-1' className='listItem listItemBorder'>
                                <div className='number-icon'>
                                    <NumberBadge number={1} />
                                </div>
                                <div id='scenario-1'>You can schedule an appointment with your advisor.</div>
                            </div>
                            <div className='listSeparator'></div>
                            <div id='scenario-step-2' className='listItem listItemBorder'>
                                <div className='number-icon'>
                                    <NumberBadge number={2} />
                                </div>
                                <div id='scenario-2'>A Certified Financial Planner™ will review your updates.</div>
                            </div>
                            <div className='listSeparator'></div>
                            <div id='scenario-step-3' className='listItem listItemBorder'>
                                <div className='number-icon'>
                                    <NumberBadge number={3} />
                                </div>
                                <div id='scenario-3'>During your appointment, you and your advisor will discuss your updates and any impact to your portfolio.</div>
                            </div>
                        </Typography>
                    </Typography>
                    <div className='listContentGap'></div>
                </div>

                <div className='sectionSeparator'></div>

                <div id='questions-container' className='sectionContainer'>
                    <Typography type='headline' scale={100} loose bold id='questions-header' className='sectionTitle'>
                        Questions?
                    </Typography>
                    <Typography id='questions-content' type='headline' scale={50}>
                        <Typography loose id='questions-sub-1' className='questionSubsection'>
                            Not all changes can be addressed through the questionnaire.
                        </Typography>
                        <Typography loose id='questions-sub-content'>
                            Interested in adding a co-client?  Should your financial plan only include you? In situations like these, we can help.
                            Call us for assistance at 1-800-225-5132.
                        </Typography>
                    </Typography>
                </div>
            </div>
            <div className='educationButtons' slot='action-zone'>
                <PsBeaconButton
                    id="cancel-rt-review"
                    variant='tertiary'
                    onclick={handleOnClose}
                >
                    Close
                </PsBeaconButton>
                <PsBeaconButton
                    id="continue-rt-review"
                    variant='primary'
                    onclick={handleOnClick}
                    style={{ whiteSpace: 'nowrap' }}
                >
                    <img style={{paddingTop: '4px'}} src={ArrowForward} slot='icon' /> Continue
                </PsBeaconButton>
            </div>
        </PsBeaconModal>
    );
}

export default function EducationModalImpl({ dispatch }) {
    return <EducationPageModal dispatch={dispatch} />
}
